import React from 'react';
import { useSidebar } from '../../context/SidebarContext';
import GlobalSidebar from './GlobalSidebar';

const SidebarContainer = () => {
  const { isCollapsed } = useSidebar();

  return (
    <div className={`global-sidebar-container ${isCollapsed ? 'collapsed' : ''}`}>
      <GlobalSidebar />
    </div>
  );
};

export default SidebarContainer;
